import React from 'react'

import { MatchProductsButton } from './MatchProductsButton'
import { MatchButtonProps } from './MatchOzonToMoySkladButton'

import { useLogic } from '../hooks/storeHook'

import { IntegrationType } from '../server/mpsklad_core/Entity/IntegrationType'
import { YmProductProp } from '../server/mpsklad_core/Models/YmProductProp'

export const ymMatchingProps = [
  [YmProductProp.ShopSku, 'Ваш SKU'],
  [YmProductProp.Name, 'Название'],
  [YmProductProp.VendorCode, 'Артикул производителя'],
  [YmProductProp.Barcode, 'Штриход']
] as const

export const MatchYandexMarketToMoySkladButton =
  (props: MatchButtonProps) => {
    const logic = useLogic()

    return (
      <MatchProductsButton
        {...props}
        fromIntegrationType={IntegrationType.YandexMarket}
        fromProps={ymMatchingProps}
        submit={logic.matchYandexMarketToMoySkladProducts}
      />
    )
  }